/** @format */

import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useNavigate } from 'react-router';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import ErrorMessage from '../../Shared/Components/ErrorMessage';
import Loading from '../../Shared/Components/Loading';
import { error } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
import { checkLogin } from '../../Shared/hooks/authenticate';
import { isValidIranianNationalCode } from '../../Shared/utils/helper';
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({
  event_id: Yup.number()
    .typeError('انتخاب رویداد الزامی است')
    .required('انتخاب رویداد الزامی است'),
  nat_code: Yup.string()
    .typeError('وارد کردن کد ملی ضروری است')
    .required('وارد کردن کد ملی ضروری است')
    .min(10, 'کد ملی باید 10 رقم باشد'),
});

const IDCard = () => {
  const [formSubmitLoading, setFormSubmitLoading] = useState(false);
  const navigation = useNavigate();
  const eventContext = useContext(EventContext);
  const [loading, setLoading] = useState(false);
  const [loadingEvents, setLoadingEvent] = useState(false);

  useEffect(() => {
    if (!checkLogin()) {
      error('برای ادامه ابتدا وارد حساب کاربری خود شوید');
      navigation('/login', { replace: true });
      return;
    }
  }, []);

  useEffect(() => {
    getCategories();
  }, []);
  const getCategories = async () => {
    setLoading(true);
    await useApi.get(
      '/category?no-paginate=true',
      {},
      (res) => {
        let data = res.data.data;

        eventContext.categories = data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };

  const selectCategory = async (slug) => {
    setLoadingEvent(true);
    await useApi.get(
      `/category/${slug}/event?no-page=true`,
      {},
      (res) => {
        let data = res.data.data;
        eventContext.events = data;
        setLoadingEvent(false);
      },
      (err) => {
        setLoadingEvent(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  const onSubmitForm = async (values, setSubmitting) => {
    if (!isValidIranianNationalCode(values.nat_code)) {
      return error('کد ملی صحیح نیست');
    }
    setSubmitting(true);
    setFormSubmitLoading(true);
    await useApi.get(
      `/id-card/${values.event_id}/user/${values.nat_code}`,
      {},
      (res) => {
        let data = res.data.data;
        if (data?.success == false) {
          setFormSubmitLoading(false);
          return error(data?.message);
        }
        setFormSubmitLoading(false);
        return navigation('/id-card/show', {
          state: res.data.data,
        });
      },
      (err) => {
        setFormSubmitLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است.');
      },
    );
  };
  return loading ? (
    <Loading />
  ) : (
    <Master
      showSidebar={false}
      containerFullWidth={true}
      headerFixed={true}
      title='دریافت آی دی کارت'
    >
      <div className='w-100 bg-dark-mode-3 d-flex flex-column vh-100'>
        <div className='d-flex flex-row border-top pt-2 bg-purple justify-content-between'>
          <div className='d-flex flex-row'>
            <i className='fad fa-calendar-check f-20 mx-2 text-dark-mode'></i>
            <h1 className='f-13 font-weight-bold text-dark-mode mt-1'>
              دریافت آی دی کارت
            </h1>
          </div>
        </div>
        <Formik
          initialValues={{
            event_id: '',
            nat_code: '',
          }}
          onSubmit={(values, { setSubmitting }) => {
            onSubmitForm(values, setSubmitting);
          }}
          validationSchema={validationSchema}
        >
          {({
            values,
            errors,
            handleChange,
            handleSubmit,
            isSubmitting,
            setFieldValue,
          }) => (
            <form onSubmit={handleSubmit}>
              <div className='row mx-2 '>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='text-dark-mode f-12 font-weight-bold'>
                      دسته بندی
                    </label>

                    <select
                      className='form-control'
                      onChange={(e) => selectCategory(e.target.value)}
                    >
                      <option value='انتخاب کنید'>انتخاب کنید</option>
                      {eventContext.categories.length > 0 &&
                        eventContext.categories?.map((item) => (
                          <option value={item?.slug}>{item?.title}</option>
                        ))}
                    </select>
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='text-dark-mode f-12 font-weight-bold'>
                      رویداد
                    </label>

                    <select
                      className='form-control'
                      name='event_id'
                      onChange={handleChange}
                      value={values.event_id}
                    >
                      <option value='انتخاب کنید'>انتخاب کنید</option>

                      {eventContext.events.length > 0 &&
                        eventContext.events.map((item) => (
                          <option value={item?.id}>{item?.title}</option>
                        ))}
                    </select>
                    <ErrorMessage error={errors.event_id} classes='my-2' />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group'>
                    <label className='my-2 text-dark-mode'>شماره ملی</label>
                    <input
                      type='text'
                      onChange={handleChange}
                      name='nat_code'
                      value={values.nat_code}
                      className='form-control'
                    />
                    <ErrorMessage error={errors.nat_code} classes='my-2' />
                  </div>
                </div>
                <div className='col-12 col-sm-12 col-md-6 col-lg-6 col-xl-6'>
                  <div className='form-group d-flex flex-row justify-content-start align-self-center mt-4'>
                    <button
                      type='submit'
                      className='btn btn-danger f-14 text-white mt-2'
                    >
                      {formSubmitLoading ? (
                        <div
                          className='spinner-border spinner-border-sm text-white mb-1 mx-2'
                          role='status'
                        ></div>
                      ) : (
                        'دریافت'
                      )}
                    </button>
                  </div>
                </div>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </Master>
  );
};

export default IDCard;
